import { render, staticRenderFns } from "./Goods.vue?vue&type=template&id=66817d91&scoped=true"
import script from "./Goods.vue?vue&type=script&lang=js"
export * from "./Goods.vue?vue&type=script&lang=js"
import style0 from "./Goods.vue?vue&type=style&index=0&id=66817d91&prod&scoped=true&lang=css"
import style1 from "./Goods.vue?vue&type=style&index=1&id=66817d91&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66817d91",
  null
  
)

export default component.exports